import React from 'react';
import styles from './university-logo.module.scss';
import Image from 'next/legacy/image';
import { Link } from '@/navigation';

type Props = {
  universityName: string;
  universityURL: string;
  universityLogoSrc: string;
  verticalAlign?: 'top' | 'center' | 'bottom';
  customModuleClass?: string;
  customHelperClass?: string;
};

export default function UniversityLogo({
  universityName,
  universityURL,
  universityLogoSrc,
  verticalAlign,
  customModuleClass,
  customHelperClass,
}: Props) {
  return (
    <div className={`${styles[customModuleClass ?? ``]} ${customHelperClass ?? ``}`}>
      <Link href={universityURL} className="d-block h-100 w-100 uni-logo image-wrapper">
        <Image
          src={universityLogoSrc}
          alt={`${universityName} logo`}
          layout="fill"
          objectFit="contain"
          objectPosition={`right ${verticalAlign || `center`}`}
        />
      </Link>
    </div>
  );
}
